// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".df-telephone__input[data-v-38ee7caa]{width:100%}.df-telephone[data-v-38ee7caa]{margin-top:15px}", ""]);
// Exports
module.exports = exports;
